module.exports = __webpack_public_path__ + "img/ecc08ecd42f312b04df547040f2e5f3.f6348bc2.png";